import { SecurityClassReadData } from "gen/model/securityClassReadData";

export const getLegalNameAnnotation = (
  securityClass: SecurityClassReadData | undefined,
) => {
  const legalNameAnnotation = securityClass?.annotations_set?.find(
    ([key]) => key == "entity_legal_name",
  );
  return (legalNameAnnotation?.[1] as string | undefined) ?? "";
};
